const settings = {
  version: '4.8.26.6',
  logs: [
    'Statuts: ✔ Terminé ◔ En cours ✘ À faire',
    '________________________________________________________',
    '✔ 4.8.26 Intégration du champ "blueprint" pour visualisation distincte des plans.',
    ' • INTERFACE: Mise à jour des interfaces: ajout/édition, import et affichage des lots.',
    ' • Ajout d\'un filtre temporaire pour cibler les lots sans "blueprint".',
    ' • API: Mise à jour des requêtes SQL et endpoint "uploadLot".',
    ' • Réécriture de la fonction uploadLot pour différencier les fichiers .zip et .pdf',
    ' • Génération XML et documentation, Intégration du champ "blueprint" et nouveaux dispositifs fiscaux.',
    ' • SQL: Ajout du champ "blueprint" (valeur vide par défaut).',
    ' • DATA: mise en ligne des 45 plans pour le programme AVEL',
    '✔ 15.7.26 Mise en place de deux filtres sur les requêtes fetch Odoo pour limiter les réponses aux dernières données créées/modifiées depuis le dernier polling.',
    ' • (27 fichiers systèmes modifiés) Cette modification permettra de garder une tracabilité sur les dates de modification et des changements d’un élément, ainsi que de son auteur, pourplus de sécurité.',
    '✔ 13.7.26 Ajout des variables lastmodified et modifiedby dans toutes les structures de table de la base de données, les fichiers de requête de l’API, ainsi que sur les modes ajout et édition de chaque page de l’interface partenaire.',
    '✘ (Si nécessaire) Détail des caractéristiques et des valeurs pour chacune des variables des 5 modèles de données récupérés via JSON.',
    '✔ 10.7.26 Ajout de 5 endpoints sécurisés et limités en accès pour permettre le transfert de données vers le CRM (programs, lots, reservations, prospects, users).',
    '✔ 10.7.26 Rédaction d’une documentation technique en markdown pour expliquer le fonctionnement de l’API côté serveur et faciliter l’intégration des endpoints.',
    '✔ 8.7.26 Ajout de la partie Prospects dans l’interface pour les utilisateurs de niveau 3 (Interne), afin de permettre au compte CRM de consulter les données clients/tiers.',
    '✔ 8.7.26 Création d’un compte utilisateur dédié à la société Sohoa pour faciliter et sécuriser les échanges de données (test en cours).',
    '✔ 8.7.26 Modification de l’API pour récupérer le token et la clé API selon le standard RFC 6750 (authentification par Bearer Token), comme implémenté côté front-end.',
    '✔ 8.7.26 Mise à jour des 43 requêtes API pour placer le token JWT et la clé API dans les en-têtes HTTP (headers), afin de permettre une intégration plus claire et sécurisée des appels depuis le CRM Odoo.'
  ],
  root: 'https://partenaires.groupeoceanic.fr',
  host: 'https://partenaires.groupeoceanic.fr/api/',
  upload: 'https://partenaires.groupeoceanic.fr/upload/',
  email: 'kartine29@gmail.com',
  logo: 'logo.png',
  program: {
    status: ['Non publié', 'En commercialisation', 'Vendu ou livré'],
    region: ['Métropole', 'Outre-mer'],
    dpe: {
      classe: ['Aucune', 'A', 'B', 'C', 'D', 'E', 'F', 'G']
    },
    certification: {
      rt: ['Aucune', 'RTAA DOM', 'RT 2012', 'RE 2020'],
      nf: ['Aucune', 'NF Habitat', 'NF Habitat HQE']
    }
  },
  lot: {
    status: ['Disponible', 'Optionné', 'Réservé', 'Financé', 'Acté'],
    law: ['Aucun', 'Pinel', 'Pinel OM', 'Pinel, Gir IS', 'Girardin', 'Girardin IS', 'RP', 'Scellier', 'Duflot', 'LMNP', 'Pinel +', 'CIOP', 'LLI', 'Jeanbrun', 'Donation', 'Coûts abordables', 'Investissement'],
    type: ['Studio', 'T1', 'T1 Bis', 'T2', 'T2 Bis', 'T3', 'T3 Bis', 'T4', 'T4 T3', 'T5', 'T6', 'T7', 'T8', 'M1', 'M2', 'M3', 'M4', 'M5', 'M6', 'M7', 'M8', 'M9', 'M10'],
    story: ['Aucune', 'Duplex', 'Triplex', 'Quadruplex'],
    st: ['', 'Dx', 'Tx', 'Qx'],
    lawyears: ['Aucune', '6', '9', '12'],
    ranges: [
      { text: '100k à 150k', min: 100000, max: 150000 },
      { text: '150k à 200k', min: 150000, max: 200000 },
      { text: '200k à 300k', min: 200000, max: 300000 },
      { text: '+ de 300k', min: 300000, max: 1000000 }
    ],
    defisc: [
      { text: '- 5k', min: 0, max: 5000 },
      { text: '5k à 10k', min: 5000, max: 10000 },
      { text: '10 à 15k', min: 10000, max: 15000 },
      { text: '+ 15k', min: 15000, max: 100000 }
    ],
    exposure: ['Nord-Ouest', 'Nord', 'Nord-Est', 'Est', 'Sud-Est', 'Sud', 'Sud-Ouest', 'Ouest', ''],
    exp: ['N.O', 'N.', 'N.E', 'E.', 'S.E', 'S.', 'S.O', 'O.', '']
  },
  user: {
    role: ['Invité', 'Utilisateur', 'Conseiller', 'Interne', 'Admin', 'SuperAdmin'],
    gender: ['Aucun', 'Mr', 'Mme']
  },
  prospect: {
    list: ['Prospect', 'Client', 'Société', 'Notaire', 'Banque']
  },
  request: {
    status: ['En attente', 'Validé', 'Refusé']
  },
  reservation: {
    status: ['Annulé', 'Optionné', 'Réservé', 'Financé', 'Acté'],
    tva: [0, 5.5, 10, 20]
  },
  stat: {
    period: ['Année', 'Trimestre', 'Mois'],
    term: ['1er Trimestre', '2ème Trimestre', '3ème Trimestre', '4ème Trimestre']
  }
}

export default settings
